import React, { useState } from 'react';

import styles from './loginForm.module.scss';
import authService from '../../utils/services/authService';
import { useNavigate } from 'react-router-dom';

const LoginForm = () => {
  const [userInfo, setUserInfo] = useState(null);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isUser, setIsUser] = useState('developer');
  const [message, setMessage] = useState('');

  const navigate = useNavigate();

  const devClickHandler = (e) => {
    e.preventDefault();
    setIsUser('developer');
  };

  const companyClickHandler = (e) => {
    e.preventDefault();
    setIsUser('company');
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    const data = {
      email: email,
      password: password,
      role: isUser,
    };
    try {
      const result = await authService.loginUser(data);
      if (isUser === 'developer') {
        if (result.data.success === true) {
          setUserInfo(result.data.data);
          if (result.data.data.createdProfile) {
            navigate(`/profile/developer/${result.data.data.userId}`);
          } else {
            navigate('/profile/developer/update');
          }
        } else if (result.status === 400) {
          setMessage('Invalid Email or Password');
        }
      } else if (isUser === 'company') {
        if (result.data.success === true) {
          setUserInfo(result.data.data);
          if (result.data.data.createdProfile) {
            navigate(`/profile/company/${result.data.data.userId}`);
          } else {
            navigate('/profile/company/update');
          }
        } else if (result.status === 400) {
          setMessage('Invalid Email or Password');
        }
      }
    } catch (error) {
      if (error.respose) {
        return error.message;
      }
    }
  };

  return (
    <section className={styles.formWrapper}>
      <h2 className={styles.loginHeading}>Sign me in as</h2>
      {message !== '' && <p className={styles.errorMsg}>{message}</p>}

      <div className={styles.choices}>
        <button
          className={`${styles.btn} ${
            isUser === 'developer' ? styles.active : ''
          }`}
          type="button"
          onClick={(e) => {
            devClickHandler(e);
          }}
        >
          Developer
        </button>
        <button
          className={`${styles.btn} ${
            isUser === 'company' ? styles.active : ''
          }`}
          type="button"
          onClick={(e) => {
            companyClickHandler(e);
          }}
        >
          Company
        </button>
      </div>
      <form className={styles.loginForm} action="">
        <div className={styles.formGroup}>
          <input
            id="email"
            type="text"
            aria-label="Email"
            placeholder="Email *"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <input
            id="password"
            type="password"
            aria-label="Password"
            placeholder="Password *"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <button
            type="submit"
            className={styles.formBtn}
            onClick={(e) => {
              submitHandler(e);
            }}
          >
            Sign in
          </button>
        </div>
      </form>
    </section>
  );
};

export default LoginForm;
